const PENDING_INVITE_KEY = 'pendingInviteToken'

export function rememberInviteToken(token?: string | null) {
  if (token) sessionStorage.setItem(PENDING_INVITE_KEY, token)
}

export function consumeInviteRedirectPath(fallback = '/'): string {
  const params = new URLSearchParams(window.location.search)
  const token = params.get('invite') || sessionStorage.getItem(PENDING_INVITE_KEY)
  if (token) {
    sessionStorage.removeItem(PENDING_INVITE_KEY)
    return '/invitations'
  }
  return fallback
}
